import React, {
  useEffect,
  useMemo,
  useState,
  useCallback,
}                                 from 'react';
import { TDataTableRow }          from '@typings/components';
import {
  IAuction,
  IFetchBid,
}                                 from '@typings/auction';
import { AUCTIONS_TABLE_HEADERS } from '@modules/auctions/utils/tableHeaders';
import { useToggle }              from '@utils/useToggle';
import {
  useFetchNadaAuctions,
  useFetchAuctionBidData,
}                                 from '@modules/auctions/queries/auctionsQueries';
import { DataTable }              from '@components/DataTable/DataTable';
import { getTableRows }           from '@modules/auctions/containers/AuctionsSearchContainer';
import { BidListModal }           from '@modules/auctions/components/BidListModal';

interface IProps {
  push      : (path: string) => void;
  invoiceId : string;
  cuid      : string;
}

export const AuctionsSortedContainer = ({
  push,
  invoiceId,
  cuid,
}: IProps): JSX.Element => {
  const [sortedAuctions, setSortedAuctions]    = useState<IAuction[]>([]);
  const [isBidListModal, toggleIsBidListModal] = useToggle();

  // #region API INTEGRATION
  const { refetch, isLoading } = useFetchNadaAuctions(
    {
      cuid,
      invoiceId,
    },
    {
      enabled   : false,
      onSuccess : (data: IAuction[]) => {
        setSortedAuctions(data);
      },
    },
  );

  const {
    mutate    : fetchBidData,
    data      : currentBid = [] as IFetchBid[],
    isLoading : isLoadingBids,
  } = useFetchAuctionBidData();
  // #endregion

  useEffect(() => {
    if (invoiceId && cuid) {
      refetch();
    }
  }, [invoiceId, cuid, refetch]);

  const handleBidListModal = useCallback(
    (auction: IAuction) => {
      fetchBidData(auction?.id);
      toggleIsBidListModal();
    },
    [fetchBidData, toggleIsBidListModal],
  );

  const tableRows = useMemo(
    (): TDataTableRow[] => getTableRows(sortedAuctions, push, handleBidListModal),
    [sortedAuctions, push, handleBidListModal],
  );

  return (
    <>
      <DataTable
        headers   = {AUCTIONS_TABLE_HEADERS}
        rows      = {tableRows}
        maxwidth  = "1680px"
        rowheight = "60px"
        loading   = {isLoading}
        aligntop
      />
      <BidListModal
        isOpen      = {isBidListModal}
        isLoading   = {isLoadingBids}
        currentBid  = {currentBid}
        toggleModal = {toggleIsBidListModal}
      />
    </>
  );
};
